export function LoadingSpinner({ size = 'md' }: { size?: 'sm' | 'md' | 'lg' }) {
  const sizes = { sm: 'h-4 w-4', md: 'h-8 w-8', lg: 'h-12 w-12' };
  return (
    <div className="flex items-center justify-center py-8">
      <div
        className={`${sizes[size]} animate-spin rounded-full border-2 border-warm-200 border-t-warm-500`}
      />
    </div>
  );
}
